<template>
  <div class="view pa24">
    <div class="d-flex mb20">
      <div class="bgf7fa pt20 pr20 pl20 pb20 d-flex flex-column mr20 w400 h130">
          <div class="d-flex align-items-center">
            <p class="fwbold fs10">{{ getPartnerCountText() }}</p>
          </div>
          <p class="fwbold fs10">{{companyInfo.partnerNum}}{{ getPersonText() }}</p>
      </div>
      <div class="bgf7fa pt20 pr20 pl20 d-flex flex-column mr20 w400 h130">
          <p class="fwbold fs10">{{ getReferralCustomerCountText() }}</p>
          <p class="fwbold fs10">{{companyInfo.customerNum}}{{ getPersonText() }}</p>
          <p class="fs7">{{ getDealtCustomerCountText() }}：{{companyInfo.customerSuccNum}}{{ getPersonText() }}</p>
      </div>
      <div class="bgf7fa pt20 pr20 pl20 d-flex flex-column w400 h130">
          <p class="fwbold fs10">{{ getTotalDealAmountText() }}</p>
          <p class="fwbold fs10">{{companyInfo.shopSell + companyInfo.manualSell}}</p>
          <p class="fs7">{{ getPromotionRewardExpenseText() }}：{{companyInfo.partnerRate + companyInfo.partnerRateWait}}({{ getIncludingPendingSettlementText() }}{{companyInfo.partnerRateWait}})</p>
          
      </div>
    </div>
    <div class="d-flex align-items-center">
      {{ getEnterpriseMemberNameText() }}：
      <el-input class="mr20 m20 w200"  v-model="keyword" :placeholder="getMemberNamePlaceholder()"></el-input>
      <el-button type="primary" @click="queryVisitorsData">{{ getSearchText() }}</el-button>
      <!-- <el-button type="primary" @click="queryVisitorsData">导出</el-button> -->
    </div>
    
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column prop="name" align="center" :label="getEnterpriseMemberText()" />
        <el-table-column prop="partnerNum" align="center" :label="getSubordinatePartnerCountText()" />
        <el-table-column prop="customerNum" align="center" :label="getReferralCustomerTotalText()"/>
        <el-table-column prop="customerSuccNum" align="center" :label="getDealtCustomerCountColumnText()"/>
        <el-table-column prop="manualSell" align="center" :label="getManualDealAmountText()" />
        <el-table-column prop="shopSell" align="center" :label="getMallTransactionAmountText()" />
        <el-table-column prop="partnerRate" align="center" :label="getPromotionRewardExpenseColumnText()"/>
        <el-table-column prop="forwardfNum" align="center" :label="getOperationText()">
          <template slot-scope="scope">
            <div class="d-flex justify-content-center" >
              <div @click="partnerListDetail(scope.row.empId)" class="cblue hover_pointer mr10">
                {{ getDetailText() }}
              </div>
            </div>
          </template>
        </el-table-column>
        
      </template>
    </commonTable>

  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import {  
  bossSubordinationBalance
 } from "@/api/financing";
import {
  employeeList,
  companyDetails,
} from "@/api/turnToIntroduce";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "visitorData",
  components: {
    commonTable,
  },
  data() {
    return {
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      staffs: [],
      userId: "",
      sourcesId: "",
      authsId: "",
      phone: "",
      totalSells:0, //收入合计
      totalPrice:0, //累计商品收入
      totalCommission:0 ,//累计佣金
      keyword:'',
      companyInfo:''
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    this.queryVisitorsData();
    this.companyDetails();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    async queryVisitorsData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        name:this.name,
      };
      try {
        this.loading = true;
        const result = await employeeList(data);
        this.loading = false;
        const { total, list } = result?.data?.pageInfo;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.tableData = []
        this.loading = false;
        console.log(error);
      }
    },
    companyDetails(){
      let data = {
        ignoer:true
      }
      companyDetails(data)
      .then((res)=>{
        console.log(res)
        if(res && res.data){
          this.companyInfo = res.data
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryVisitorsData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryVisitorsData();
    },
    partnerListDetail(id){
      this.$router.push({ path:`/partnerListDetailList?id=${id}` });
    },
    
    // 多语言方法
    getCurrentLanguage() {
      let currentLanguage = this.$store.state.currentLanguage;
      if (!currentLanguage) {
        currentLanguage = localStorage.getItem('language') || 'zh-TW';
      }
      return currentLanguage;
    },
    
    getPartnerCountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '合作伙伴数',
        'zh-TW': '合作夥伴數',
        'en': 'Partner Count'
      };
      return textMap[currentLanguage] || '合作伙伴数';
    },
    
    getPersonText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '人',
        'zh-TW': '人',
        'en': 'Person'
      };
      return textMap[currentLanguage] || '人';
    },
    
    getReferralCustomerCountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '转介绍客户数',
        'zh-TW': '轉介紹客戶數',
        'en': 'Referral Customer Count'
      };
      return textMap[currentLanguage] || '转介绍客户数';
    },
    
    getDealtCustomerCountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '已成交客户数',
        'zh-TW': '已成交客戶數',
        'en': 'Dealt Customer Count'
      };
      return textMap[currentLanguage] || '已成交客户数';
    },
    
    getTotalDealAmountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '成交总金额',
        'zh-TW': '成交總金額',
        'en': 'Total Deal Amount'
      };
      return textMap[currentLanguage] || '成交总金额';
    },
    
    getPromotionRewardExpenseText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '推广赏金支出金额',
        'zh-TW': '推廣賞金支出金額',
        'en': 'Promotion Reward Expense'
      };
      return textMap[currentLanguage] || '推广赏金支出金额';
    },
    
    getIncludingPendingSettlementText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '包含待结算',
        'zh-TW': '包含待結算',
        'en': 'Including Pending Settlement'
      };
      return textMap[currentLanguage] || '包含待结算';
    },
    
    getEnterpriseMemberNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '企业成员名称',
        'zh-TW': '企業成員名稱',
        'en': 'Enterprise Member Name'
      };
      return textMap[currentLanguage] || '企业成员名称';
    },
    
    getMemberNamePlaceholder() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '成员名称',
        'zh-TW': '成員名稱',
        'en': 'Member Name'
      };
      return textMap[currentLanguage] || '成员名称';
    },
    
    getSearchText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '搜索',
        'zh-TW': '搜索',
        'en': 'Search'
      };
      return textMap[currentLanguage] || '搜索';
    },
    
    getEnterpriseMemberText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '企业成员',
        'zh-TW': '企業成員',
        'en': 'Enterprise Member'
      };
      return textMap[currentLanguage] || '企业成员';
    },
    
    getSubordinatePartnerCountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '拥有下级合作伙伴数',
        'zh-TW': '擁有下級合作夥伴數',
        'en': 'Subordinate Partner Count'
      };
      return textMap[currentLanguage] || '拥有下级合作伙伴数';
    },
    
    getReferralCustomerTotalText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '转介绍客户总数',
        'zh-TW': '轉介紹客戶總數',
        'en': 'Referral Customer Total'
      };
      return textMap[currentLanguage] || '转介绍客户总数';
    },
    
    getDealtCustomerCountColumnText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '已成交客户数',
        'zh-TW': '已成交客戶數',
        'en': 'Dealt Customer Count'
      };
      return textMap[currentLanguage] || '已成交客户数';
    },
    
    getManualDealAmountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '录入成交金额',
        'zh-TW': '錄入成交金額',
        'en': 'Manual Deal Amount'
      };
      return textMap[currentLanguage] || '录入成交金额';
    },
    
    getMallTransactionAmountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '商城交易金额',
        'zh-TW': '商城交易金額',
        'en': 'Mall Transaction Amount'
      };
      return textMap[currentLanguage] || '商城交易金额';
    },
    
    getPromotionRewardExpenseColumnText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '推广赏金支出金额',
        'zh-TW': '推廣賞金支出金額',
        'en': 'Promotion Reward Expense'
      };
      return textMap[currentLanguage] || '推广赏金支出金额';
    },
    
    getOperationText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '操作',
        'zh-TW': '操作',
        'en': 'Operation'
      };
      return textMap[currentLanguage] || '操作';
    },
    
    getDetailText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '详情',
        'zh-TW': '詳情',
        'en': 'Details'
      };
      return textMap[currentLanguage] || '详情';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>